<template>
    <v-container class="MainLayout-wrapper">
        <header class="MainLayout-header">
            <Header></Header>
        </header>
        <sidebar></sidebar>
        <main class="MainLayout-main">
            <slot/>
        </main>
    </v-container>
</template>

<script>
import Header from '../common/Header.vue';
import Sidebar from '../common/Sidebar.vue';

export default {
  name: 'MainLayout',
  components: {
    Sidebar,
    Header,
  },
};
</script>

<style scoped lang="sass">
    .MainLayout-wrapper
        padding-bottom: 50px
    #MainLayout-menu-toggler
        position: relative
        z-index: 100

    .MainLayout-header
        min-height: 100px
        color: #fff
</style>
